import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AlertController, IonSlides, ModalController } from '@ionic/angular';
import { ConfigService } from '../../../service/config/config.service';
import { AuthService } from '../../../service/auth/auth.service';
import { LocaldataService } from '../../../service/localdata/localdata.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NgForm } from '@angular/forms';

import { DatePipe, DecimalPipe } from '@angular/common';

@Component({
  selector: 'app-protamylasseorder',
  templateUrl: './protamylasseorder.page.html',
  styleUrls: ['./protamylasseorder.page.scss'],
  providers: [DecimalPipe]
})
export class ProtamylasseorderPage implements OnInit {

  @ViewChild('slides') slides: IonSlides;
  //@ViewChild('slides', {static: true}) slides: IonicSlides;

  private appversion;
  private appplatform;
  private deviceinfo;

  private form: any;
  private factory: Factory;
  private year: string;

  public amount: number;
  public amountextra: number;

  private totalamount: string;
  private maxamount: number = 0;
  private maxamountString: string;
  

  private deliveryState: string;

  public formSubmitting: boolean = false;

  private selectedDeliveryPartner: string;

  private stamdataIsLoaded: boolean = false;

  private deliveryOptions: string[] = ['Hjortlund Maskinstation, Grindsted','Brdr. Rasmussen A/S, Kibæk','Midtjydsk Maskinstation, Brande', 'Dyrbjerggaard Maskinstation A/S, Karup','Søndergaards Maskinstation, Løgumkloster','Jejsing Maskinstation, Tønder','Maskinstation, Hans Tobiasen, Ribe']; //, 'Skamstrup Maskinstation, Hodde'


  @Input() modalCtrl: ModalController;
  @Input() formobject: any;

  constructor(private route: ActivatedRoute, public config: ConfigService, private auth: AuthService, private localData: LocaldataService ,private alertCtrl: AlertController, private http: HttpClient, private decimalPipe: DecimalPipe, private datePipe: DatePipe) {

    this.appversion = this.config.version;
    this.appplatform = this.config.platformName;
    this.deviceinfo = this.config.deviceinfo;

  }

  async nextSlide(){
    let slideNumber = await this.slides.getActiveIndex();
//console.log(slideNumber)

    if(slideNumber===2){
      if(!this.amount){
        let alert = await this.alertCtrl.create({
          header: 'Manglende mængde',
          message: 'Du skal udfylde den ønskede mængde',
          buttons: ['OK'],
        });
        await alert.present();
        return;
      }
      if(this.amount>this.maxamount){
        let alert = await this.alertCtrl.create({
          header: 'Mængde overskredet',
          message: 'Den maksimale mængde du kan bestille er overskredet.',
          buttons: ['OK'],
        });
        await alert.present();
        return;
      }
    }


    if(slideNumber===4){
      if(this.deliveryState==='delivery' && !this.selectedDeliveryPartner){
        let alert = await this.alertCtrl.create({
          header: 'Manglende maskinstation',
          message: 'Du skal vælge den ønskede maskinstation',
          buttons: ['OK'],
        });
        await alert.present();
        return;
      }
    }

    this.slides.slideNext();
  }

  changeDeliveryState(paramState:string){
    this.deliveryState = paramState;
    console.log('deliveryState', this.deliveryState)
  }

  changeDeliveryOption(paramOption:string){
    this.selectedDeliveryPartner = paramOption;
    console.log('deliveryOption', this.selectedDeliveryPartner)
  }

  async submitForm(orderForm:NgForm) {

    this.formSubmitting = true;

    

    var submitformdata =
      {
        "systemname": this.form.systemname,
        "displayname": this.form.displayname,
        "completed": true,
        "year": this.form.year,
        "data": orderForm.value,
        "factoryId": this.form.factoryId,
        "farmerId": this.auth.userProfile.id,
        "formavailableId": this.form.id
      }


      let headers: HttpHeaders = new HttpHeaders();
      headers = headers.append('Content-Type', 'application/json');
      headers = headers.append('Authorization', localStorage.getItem('access_token') || '{}');
  
      const options = {
        headers: headers
      };

      this.http.post(this.config.basePath + '/api/forms', submitformdata, options)
      .subscribe(
        (res) => {
  
            if (res) {
              //if (res.status === 200) {
  
                if(this.form.onceperyear){
                  this.form.status = 'completed';
                }
  
                this.localData.remoteUpdateFormsAvailable().then(() =>{
                  this.nextSlide();
                });
  
              
            }
          },
          (err) => {
  
            this.submitError();
  
          }
        );

    console.log('submitformdata', submitformdata)

    //this.nextSlide();
  }

  async submitError(){
    let alert = await this.alertCtrl.create({
      header: 'Der opstod en fejl ved indsendelse',
      message: 'Prøv igen. Hvis problemet fortsætter kontakt da venligst ' + this.factory.displayname,
      buttons: ['OK'],
    });
    await alert.present();
  }

  completeSubmission(){
    this.closeModal();
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  formatNumber(num: number): string {
    return this.decimalPipe.transform(num, '1.0-0').replace(',', '.');
  }
  getFormattedDate(dateStr: string): string {
    let date = this.datePipe.transform(dateStr, 'dd-MM-yy');
    let time = this.datePipe.transform(dateStr, 'HH.mm');
    return `Senest opdateret: ${date} Kl. ${time}`;
  }

  public async getStamdata(): Promise<any>{
    if(this.auth.userProfile){
      let headers: HttpHeaders = new HttpHeaders();
      headers = headers.append('Content-Type', 'application/json');
      headers = headers.append('Authorization', localStorage.getItem('access_token') || '{}');

      const options = {
        headers: headers
      };
      return new Promise((resolve, reject) => {
        const url = `${this.config.basePath}/api/farmers/${this.auth.userProfile.id}?filter=${encodeURIComponent(JSON.stringify({ include: 'masterdata' }))}`;
        this.http.get<any[]>(url, options)
        .subscribe((data)=>{
          this.totalamount = this.formatNumber(data['masterdata'][0].total_amount);
          this.maxamountString = this.formatNumber(Math.round(data['masterdata'][0].total_amount/500*3.55));
          this.maxamount = Math.round(data['masterdata'][0].total_amount/500*3.55);
          
          resolve(data['masterdata'][0].total_amount);
        })   
      }) 
    }
  }

  ngOnInit() {
    this.form = this.formobject;
      console.log('log', this.formobject)
      this.factory = this.formobject.factory;
      this.year = this.formobject.year;

    this.getStamdata().then(data => {
      //console.log('DATA', data)
      this.stamdataIsLoaded = true;
    })



  }

}


export interface Factory {
  id: any;
  displayname: any;
  address: any;
}

export interface Form {
  component: any;
  createdAt: any;
  createdBy: any;
  deadline: any;
  deletedAt: any;
  deletedBy: any;
  displayDeadline: any;
  displayIcon: any;
  displayname: any;
  factory: any;
  factoryId: any;
  formproperties: any;
  forms: any;
  id: any;
  isSoldOut: any;
  isSpecial: any;
  msgAlreadySubmitted: any;
  msgDateOutOfRange: any;
  onceperyear: any;
  orderYear: any;
  publisher: any;
  soldOutMsg: any;
  status: any;
  systemname: any;
  tandc: any;
  updatedAt: any;
  updatedBy: any;
  year: any;
}